export default function SVG_Path() {
  return (
    <div>
      <h1>SVG_Path Component</h1>
    </div>
  );
}
